import { render } from "./UsageStats.vue?vue&type=template&id=bedc1fba"
import script from "./UsageStats.vue?vue&type=script&lang=js"
export * from "./UsageStats.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__